import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: {
    success: false,
    pageInfo: null,
    messages: [],
    result: [{
      Id: 1
      , Title: "طرح الماس"
      , Plans: [{
        Id: 1
        , Amount: "300/000/000"
        , ExpirationDate: "01/07/01"
        , LoanCount: 18,
      }, {
        Id: 1
        , Amount: "29/000/000"
        , ExpirationDate: "01/07/01"
        , LoanCount: 18,
      }, {
        Id: 1
        , Amount: "29/000/000"
        , ExpirationDate: "01/07/01"
        , LoanCount: 18,
      }, {
        Id: 1
        , Amount: "29/000/000"
        , ExpirationDate: "01/07/01"
        , LoanCount: 18,
      }, {
        Id: 1
        , Amount: "29/000/000"
        , ExpirationDate: "01/07/01"
        , LoanCount: 18,
      }, {
        Id: 1
        , Amount: "29/000/000"
        , ExpirationDate: "01/07/01"
        , LoanCount: 18,
      }]
    },{
      Id: 1
      , Title: "طرح مروارید"
      , Plans: [{
        Id: 1
        , Amount: "300/000/000"
        , ExpirationDate: "01/07/01"
        , LoanCount: 18,
      }, {
        Id: 1
        , Amount: "29/000/000"
        , ExpirationDate: "01/07/01"
        , LoanCount: 18,
      }, {
        Id: 1
        , Amount: "29/000/000"
        , ExpirationDate: "01/07/01"
        , LoanCount: 18,
      }, {
        Id: 1
        , Amount: "29/000/000"
        , ExpirationDate: "01/07/01"
        , LoanCount: 18,
      }, {
        Id: 1
        , Amount: "29/000/000"
        , ExpirationDate: "01/07/01"
        , LoanCount: 18,
      }, {
        Id: 1
        , Amount: "29/000/000"
        , ExpirationDate: "01/07/01"
        , LoanCount: 18,
      }]
    }],
    totalCount: 0
  }
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const Slice = createSlice({
  name: "facilityPlan",
  initialState: initialState,
  reducers: {
    listFetched: (state, action) => {
      const { success, pageInfo, messages, result } = action.payload;
      state.list.success = success;
      state.list.pageInfo = pageInfo;
      state.list.messages = messages;
      state.list.result = result;
    }
  }
});
